<template>
  <div class="pagination-footer-box flex-center" :style="[pfbSidebar
  ? {justifyContent: 'space-between'} : null, {
    backgroundColor: pfbStyle.backgroundColor
  }]">
    <div class="pagination-wrapper flex-center" :style="[!pfbSidebar
  ? {order: '2', marginLeft: '27px'} : null]">
      <div class="pagination-rows">
        <div class="select-box">
          <select id="pagination-select" v-model="rowsPerPageActive">
            <option v-for="(rows, index) in pfbRowsPerPage"
                    class="n-i n-i-arrow-down-b"
                    :key="index"
                    :value="rows">
             {{rows}}
            </option>
          </select>
        </div>
        <div class="pagination-rows-title">
          <span>{{'admin_rows' | translate}}</span>
          <span>{{'admin_perPage' | translate}}</span>
        </div>
      </div>
      <PaginationBox class="pagination"
                     :pb-rows-per-page-active="pfbRowsPerPageActive"
                     v-on:pagination-active-page="$emit('pagination-active-page', $event)"
                     :active-page="activePage"
                     :pb-pagination="pfbPagination">Pagination</PaginationBox>
    </div>
    <div class="total-results">
      <span>
        {{'admin_totalResults' | translate}}
      </span>
      <span>{{pfbPagination.total}}</span>
    </div>
  </div>
</template>

<script>
import PaginationBox from './PaginationBox';

export default {
  name: 'PaginationFooterBox',
  components: { PaginationBox },
  props: [
    'pfbPagination',
    'pfbStyle',
    'pfbSidebar',
    'pfbRowsPerPage',
    'pfbRowsPerPageActive',
    'activePage',
  ],
  computed: {
    rowsPerPageActive: {
      set(value) {
        this.$emit('update-rows-per-page', value);
      },
      get() {
        return this.pfbRowsPerPageActive;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
  .pagination-footer-box {
    border-top: 1px solid #d3dadd;
    font-size: 12px;
    height: 100%;
    padding: 0 20px;
    .total-results {
      span {
        display: inline-block;
        &:first-child {
          &:first-letter {
            text-transform: capitalize;
          }
        }
        &:last-child {
          font-family: primary-font-bold;
        }
      }
    }
    .total-results,
    .pagination-wrapper {
      height: 30px;
    }
    .total-results,
    .pagination-rows-title {
      display: flex;
      flex-direction: column;
      line-height: 1.2;
    }
    .pagination-wrapper {
      .pagination-rows {
        display: flex;
        height: 100%;
        .select-box {
          color: #808b9c;
          height: 100%;
          position: relative;
          select {
            background-color: #fff;
            border: 1px solid #e9ecee;
            color: inherit;
            height: 100%;
            line-height: 30px;
            padding-left: 5px;
            width: 65px;
          }
        }
        .pagination-rows-title {
          padding-left: 8px;
          opacity: .5;
          span:first-child {
            text-transform: capitalize;
          }
        }
      }
      .pagination {
        padding-left: 40px;
      }
    }
  }
</style>
